// ============================================================
// cf-treetable.js � Reusable Tree Table helper
// Load hanya pada halaman yang menggunakan Tree Table.
//
// Dependencies: site.js (CF.appConfig), jQuery
//
// NOT a DataTables plugin � tree tables have parent/child
// hierarchy that DataTables' flat row model cannot handle.
// Instead, this mirrors the CF.dataTable.init() API so
// page scripts use the exact same pattern.
//
// Auto-injects (tidak perlu ditulis di cshtml):
//   - table-toolbar-top  (search, columns toggle, expand/collapse, actions)
//   - filter-bar         (active filter chips � only if #filter-body exists)
//   - row-ctx-menu       (row context menu)
//   - table-toolbar-bottom (page size, row info, pagination)
//   - tree-summary bar
//
// Yang TETAP ditulis di cshtml:
//   - <table> dengan <thead>
//   - filter modal body (#filter-body) � custom form fields (optional)
//
// Server-side mode (optional callbacks):
//   onServerSearch:   function(query) { }

//   When these callbacks are provided, the tree table delegates
//   search/paging to the page script instead of doing it client-side.
//   Use CF.treeTable.updateData(uid, data, serverPagination) to
//   re-render after API call.
//
// Usage:
//   var tt = CF.treeTable.init('#myTree', {
//       data: [...],
//       columns: [...],
///      idField: 'id',
//       parentField: 'pid',
//       depthField: 'depth',
//       // Server-side pagination info (optional)
//       serverPagination: { page: 1, pageSize: 10, totalCount: 87, totalPages: 9 },
//       // Server-side callbacks (optional)
//       onServerSearch:   function(q) { loadFromApi(q); },
//       onServerPage:     function(page, pageSize) { loadFromApi(null, page, pageSize); },
//       onServerPageSize: function(pageSize) { loadFromApi(null, 1, pageSize); }
//   });
//
//   // After API call, update the tree:
//   CF.treeTable.updateData(tt.uid, newData, newServerPagination);
// ============================================================

window.CF = window.CF || {};

(function () {
    'use strict';

    var _treeCounter = 0;
    var _treeRegistry = {};

    CF.treeTable = (function () {

        // � Build tree data structures -----------------------
        function _buildTree(data, opts) {
            var idF = opts.idField || 'id';
            var pidF = opts.parentField || 'pid';
            var depthF = opts.depthField || 'depth';

            var nodeMap = {};
            var childMap = {};
            var rootIds = [];

            // First pass: index all nodes by id
            data.forEach(function (d) {
                nodeMap[d[idF]] = d;
            });

            // Second pass: build parent-child relationships
            // If a node has a parentId but that parent is NOT in the data set,
            // treat the node as a root (orphan promotion for server-side pagination)
            data.forEach(function (d) {
                var pid = d[pidF];
                if (pid === null || pid === undefined || pid === '') {
                    rootIds.push(d[idF]);
                } else if (!nodeMap[pid]) {
                    // Parent not in current data set � promote to root
                    rootIds.push(d[idF]);
                } else {
                    if (!childMap[pid]) childMap[pid] = [];
                    childMap[pid].push(d[idF]);
                }
            });

            // Compute depth if not present
            if (data.length > 0 && data[0][depthF] === undefined) {
                var computeDepth = function (id, depth) {
                    if (nodeMap[id]) nodeMap[id][depthF] = depth;
                    if (childMap[id]) {
                        childMap[id].forEach(function (cid) { computeDepth(cid, depth + 1); });
                    }
                };
                rootIds.forEach(function (rid) { computeDepth(rid, 0); });
            }

            // Build flat ordered list (DFS order) for rendering
            var ordered = [];
            var walk = function (id) {
                ordered.push(id);
                if (childMap[id]) {
                    childMap[id].forEach(function (cid) { walk(cid); });
                }
            };
            rootIds.forEach(function (rid) { walk(rid); });

            return {
                nodeMap: nodeMap,
                childMap: childMap,
                rootIds: rootIds,
                ordered: ordered
            };
        }

        // � Get root ancestor of a node ----------------------
        function _getRootId(id, nodeMap, pidF) {
            var n = nodeMap[id];
            if (!n) return id;
            var pid = n[pidF];
            if (pid === null || pid === undefined || pid === '') return id;
            return _getRootId(pid, nodeMap, pidF);
        }

        // � Check if all ancestors are expanded --------------
        function _isAncestorExpanded(node, nodeMap, expandedMap, pidF) {
            var pid = node[pidF];
            if (pid === null || pid === undefined || pid === '') return true;
            var parent = nodeMap[pid];
            if (!parent) return true; // parent not in data set (orphan-promoted root)
            if (!expandedMap[pid]) return false;
            return _isAncestorExpanded(parent, nodeMap, expandedMap, pidF);
        }

        // � Pagination helpers -------------------------------
        function _pageRangeArr(cur, total) {
            if (total <= 7) return Array.from({ length: total }, function (_, i) { return i; });
            if (cur < 4) return [0, 1, 2, 3, 4, '\u2026', total - 1];
            if (cur > total - 5) return [0, '\u2026', total - 5, total - 4, total - 3, total - 2, total - 1];
            return [0, '\u2026', cur - 1, cur, cur + 1, '\u2026', total - 1];
        }

        // � Check if server-side mode -----------------------
        function _isServerMode(ctx) {
            return !!(ctx.opts.onServerPage || ctx.opts.onServerSearch || ctx.opts.onServerPageSize || ctx.opts.onServerSort);
        }

        // � Render pagination --------------------------------
        function _renderPagination(ctx) {
            var serverMode = _isServerMode(ctx);
            var sp = ctx.serverPagination;

            var rootCount, totalCount, totalPages, curPage, pageSize;

            if (serverMode && sp) {
                // Server-side: use server pagination metadata
                totalCount = sp.totalCount || 0;
                totalPages = sp.totalPages || 1;
                curPage    = (sp.page || 1) - 1; // 0-based for internal use
                pageSize   = sp.pageSize || ctx.pageSize;
                rootCount  = ctx.tree.rootIds.length; // nodes on this page
            } else {
                // Client-side: paginate by root nodes
                rootCount  = ctx.tree.rootIds.length;
                totalCount = rootCount;
                totalPages = Math.max(1, Math.ceil(rootCount / ctx.pageSize));
                curPage    = ctx.currentPage;
                pageSize   = ctx.pageSize;
            }

            var start, end;
            if (serverMode && sp) {
                start = totalCount === 0 ? 0 : (curPage * pageSize) + 1;
                end   = Math.min(start + rootCount - 1, totalCount);
            } else {
                start = totalCount === 0 ? 0 : curPage * pageSize + 1;
                end   = Math.min(start + pageSize - 1, totalCount);
            }

            var rowInfoEl = document.getElementById(ctx.footerIds.rowInfoId);
            if (rowInfoEl) {
                if (totalCount === 0) {
                    rowInfoEl.textContent = 'No entries';
                } else if (serverMode) {
                    rowInfoEl.textContent = 'Showing ' + start + '\u2013' + end + ' of ' + totalCount + ' entries';
                } else {
                    rowInfoEl.textContent = 'Showing ' + start + '\u2013' + end + ' of ' + totalCount + ' root entries';
                }
            }

            var wrap = document.getElementById(ctx.footerIds.paginationWrapId);
            if (!wrap) return;

            var uid = ctx.uid;
            var btns = '';
            btns += '<button class="pg-btn' + (curPage === 0 ? ' disabled' : '') + '" onclick="CF.treeTable._goPage(' + uid + ',0)" title="First"><i class="fa-solid fa-angles-left"></i></button>';
            btns += '<button class="pg-btn' + (curPage === 0 ? ' disabled' : '') + '" onclick="CF.treeTable._goPage(' + uid + ',' + (curPage - 1) + ')" title="Prev"><i class="fa-solid fa-angle-left"></i></button>';

            _pageRangeArr(curPage, totalPages).forEach(function (p) {
                if (p === '\u2026') {
                    btns += '<button class="pg-btn ellipsis">\u2026</button>';
                    return;
                }
                btns += '<button class="pg-btn' + (p === curPage ? ' active' : '') +
                    '" onclick="CF.treeTable._goPage(' + uid + ',' + p + ')">' + (p + 1) + '</button>';
            });

            btns += '<button class="pg-btn' + (curPage >= totalPages - 1 || totalPages === 0 ? ' disabled' : '') + '" onclick="CF.treeTable._goPage(' + uid + ',' + (curPage + 1) + ')" title="Next"><i class="fa-solid fa-angle-right"></i></button>';
            btns += '<button class="pg-btn' + (curPage >= totalPages - 1 || totalPages === 0 ? ' disabled' : '') + '" onclick="CF.treeTable._goPage(' + uid + ',' + (totalPages - 1) + ')" title="Last"><i class="fa-solid fa-angles-right"></i></button>';

            wrap.innerHTML = btns;
        }

        // � Render a single row ------------------------------
        function _renderRow(ctx, nodeId) {
            var node = ctx.tree.nodeMap[nodeId];
            if (!node) return '';

            var uid = ctx.uid;
            var idF = ctx.opts.idField || 'id';
            var pidF = ctx.opts.parentField || 'pid';
            var depthF = ctx.opts.depthField || 'depth';
            var depth = node[depthF] || 0;
            var hasChildren = !!(ctx.tree.childMap[nodeId] && ctx.tree.childMap[nodeId].length);
            var isExpanded = !!ctx.expandedMap[nodeId];

            // Determine visibility � use rootIds to detect promoted orphans
            var isTreeRoot = (ctx.tree.rootIds.indexOf(nodeId) >= 0);
            var hidden = false;

            if (_isServerMode(ctx)) {
                // Server mode: all returned nodes belong to current page
                // Only hide children whose parent is collapsed
                if (!isTreeRoot && !_isAncestorExpanded(node, ctx.tree.nodeMap, ctx.expandedMap, pidF)) hidden = true;
            } else {
                // Client mode: paginate by root
                var pageRoots = ctx.tree.rootIds.slice(ctx.currentPage * ctx.pageSize, (ctx.currentPage + 1) * ctx.pageSize);
                var rootId = _getRootId(nodeId, ctx.tree.nodeMap, pidF);
                if (pageRoots.indexOf(rootId) === -1) hidden = true;
                if (!isTreeRoot && !_isAncestorExpanded(node, ctx.tree.nodeMap, ctx.expandedMap, pidF)) hidden = true;
            }

            var cls = hidden ? ' class="tt-hidden"' : '';

            // Build cells
            var cells = '';
            ctx.opts.columns.forEach(function (col, colIdx) {
                var val = col.field ? node[col.field] : '';
                var style = ctx.colVisible[colIdx] === false ? ' style="display:none"' : '';

                if (col.tree) {
                    // Tree column � indentation + toggler/leaf
                    var indent = depth * 22;
                    var safeId = "'" + String(nodeId).replace(/'/g, "\\'") + "'";
                    var toggler = hasChildren
                        ? '<button class="tt-toggler" onclick="CF.treeTable._toggle(' + uid + ',' + safeId + ')">' +
                            '<i class="fa-solid ' + (isExpanded ? 'fa-chevron-down' : 'fa-chevron-right') + '"></i>' +
                          '</button>'
                        : '<span class="tt-leaf-dot"></span>';

                    var depthCls = depth <= 2 ? 'tt-node-name-' + depth : 'tt-node-name-2';

                    var rendered = (col.render ? col.render(val, node) : val) || '';
                    cells += '<td' + style + '>' +
                        '<div class="tt-cell-wrap" style="padding-left:' + indent + 'px">' +
                            toggler +
                            '<span class="' + depthCls + '">' + rendered + '</span>' +
                        '</div>' +
                    '</td>';
                } else if (col.action) {
                    // Kebab action column
                    cells += '<td style="text-align:center">' +
                        '<button class="kebab-btn" onclick="openRowMenu(event,this)">' +
                            '<i class="fa-solid fa-ellipsis-vertical"></i>' +
                        '</button>' +
                    '</td>';
                } else {
                    var rendered = (col.render ? col.render(val, node) : val);
                    if (rendered === undefined || rendered === null) rendered = '';
                    cells += '<td' + style + '>' + rendered + '</td>';
                }
            });

            return '<tr id="tt-row-' + uid + '-' + nodeId + '" data-id="' + nodeId + '"' + cls + '>' + cells + '</tr>';
        }

        // � Full render --------------------------------------
        function _renderAll(ctx) {
            var tbody = ctx.tableEl.querySelector('tbody');
            if (!tbody) return;
            var html = '';
            ctx.tree.ordered.forEach(function (id) {
                html += _renderRow(ctx, id);
            });
            tbody.innerHTML = html;
            _renderPagination(ctx);
            _renderSummary(ctx);
        }

        // � Refresh visibility only (no re-render) ----------
        function _refreshVisibility(ctx) {
            var pidF = ctx.opts.parentField || 'pid';

            if (_isServerMode(ctx)) {
                // Server mode: all nodes on current page, just check expand/collapse
                ctx.tree.ordered.forEach(function (id) {
                    var tr = document.getElementById('tt-row-' + ctx.uid + '-' + id);
                    if (!tr) return;
                    var node = ctx.tree.nodeMap[id];
                    var isTreeRoot = (ctx.tree.rootIds.indexOf(id) >= 0);
                    var hidden = !isTreeRoot && !_isAncestorExpanded(node, ctx.tree.nodeMap, ctx.expandedMap, pidF);
                    if (hidden) { tr.classList.add('tt-hidden'); } else { tr.classList.remove('tt-hidden'); }
                });
            } else {
                // Client mode: paginate by root
                var pageRoots = ctx.tree.rootIds.slice(ctx.currentPage * ctx.pageSize, (ctx.currentPage + 1) * ctx.pageSize);
                ctx.tree.ordered.forEach(function (id) {
                    var tr = document.getElementById('tt-row-' + ctx.uid + '-' + id);
                    if (!tr) return;
                    var node = ctx.tree.nodeMap[id];
                    var isTreeRoot = (ctx.tree.rootIds.indexOf(id) >= 0);
                    var rootId = _getRootId(id, ctx.tree.nodeMap, pidF);
                    var hidden = false;
                    if (pageRoots.indexOf(rootId) === -1) hidden = true;
                    if (!isTreeRoot && !_isAncestorExpanded(node, ctx.tree.nodeMap, ctx.expandedMap, pidF)) hidden = true;
                    if (hidden) { tr.classList.add('tt-hidden'); } else { tr.classList.remove('tt-hidden'); }
                });
            }

            _renderPagination(ctx);
        }

        // � Render summary bar -------------------------------
        function _renderSummary(ctx) {
            var summaryEl = document.getElementById('tt-summary-' + ctx.uid);
            if (!summaryEl || !ctx.opts.summary) return;

            var allNodes = ctx.tree.ordered.map(function (id) { return ctx.tree.nodeMap[id]; });
            var html = '';
            ctx.opts.summary.forEach(function (s) {
                var count = typeof s.countFn === 'function' ? s.countFn(allNodes) : 0;
                html += '<span class="sum-item">' +
                    '<span class="sum-dot" style="background:' + s.color + '"></span> ' +
                    s.label + ': <strong>' + count + '</strong>' +
                '</span>';
            });
            summaryEl.innerHTML = html;
        }

        // � Inject toolbar top -------------------------------
        //
        // If .table-toolbar-top already exists in the cshtml, adopt it
        // by wiring up event handlers via data-cf-* attributes.
        // Otherwise fall back to auto-generating the toolbar.
        function _injectToolbarTop(card, uid, columns, actions, hasFilter, primaryAction) {
            var existingToolbar = card.querySelector('.table-toolbar-top');

            if (existingToolbar) {
                // ?? Adopt existing toolbar from cshtml ??????
                _adoptToolbarTop(existingToolbar, uid, columns, actions, hasFilter, primaryAction);
                return;
            }

            // ?? Auto-generate toolbar (legacy fallback) ?????
            var colPopupId = 'tt-col-popup-' + uid;
            var actPopupId = 'tt-act-popup-' + uid;
            var searchId   = 'tt-search-'    + uid;

            // Column toggle items � read titles from <thead th> in the table
            var tableEl = card.querySelector('table');
            var headerCells = tableEl ? tableEl.querySelectorAll('thead th') : [];

            var colItems = '';
            columns.forEach(function (col, i) {
                if (col.tree || col.action) return;
                var thEl = headerCells[i];
                var title = (thEl ? thEl.textContent.trim() : '') || col.title || '';
                if (!title) return;
                colItems += '<label class="col-toggle-item">' +
                    '<input type="checkbox" checked onchange="CF.treeTable._toggleColumn(' + uid + ',' + i + ',this.checked)" />' +
                    title +
                '</label>';
            });

            // Actions dropdown items
            var actItems = '';
            if (actions && actions.length) {
                actions.forEach(function (a, idx) {
                    if (a.divider) {
                        actItems += '<div class="pm-divider"></div>';
                    } else {
                        actItems += '<div class="pm-item' + (a.danger ? ' danger' : '') + '"' +
                            ' onclick="CF.treeTable._onAction(' + uid + ',' + idx + ')">' +
                            '<span class="pm-icon"><i class="' + (a.icon || '') + '"></i></span>' +
                            a.label +
                        '</div>';
                    }
                });
            }

            var hasActions = actions && actions.some(function (a) { return !a.divider; });
            var actionsBtn = '';
            if (hasActions) {
                actionsBtn =
                    '<div class="popup-wrap">' +
                        '<button class="tb-btn tb-btn-secondary" onclick="togglePopup(\'' + actPopupId + '\')">' +
                            'Actions <i class="fa-solid fa-chevron-down" style="font-size:9px;margin-left:2px"></i>' +
                        '</button>' +
                        '<div id="' + actPopupId + '" class="actions-popup popup-menu">' +
                            actItems +
                        '</div>' +
                    '</div>';
            }

            // Primary action button � standalone, left of Actions dropdown
            var primaryBtn = '';
            if (primaryAction) {
                var primaryPermAttr = primaryAction.permission
                    ? ' data-cf-permission="' + primaryAction.permission + '"'
                    : '';
                primaryBtn =
                    '<button class="tb-btn tb-btn-primary"' + primaryPermAttr +
                        ' onclick="CF.treeTable._onPrimaryAction(' + uid + ')">' +
                        (primaryAction.icon ? '<i class="' + primaryAction.icon + '"></i> ' : '') +
                        primaryAction.label +
                    '</button>';
            }

            // Filter button � only inject if page has #filter-body
            var filterBtn = '';
            if (hasFilter) {
                filterBtn =
                    '<button class="tb-btn" onclick="openFilterModal()">' +
                        '<i class="fa-solid fa-sliders"></i> Filter' +
                        '<span class="filter-badge" id="filter-badge">0</span>' +
                    '</button>';
            }

            var html =
                '<div class="table-toolbar-top">' +
                    '<div class="toolbar-search">' +
                        '<i class="fa-solid fa-magnifying-glass"></i>' +
                        '<input type="text" id="' + searchId + '" placeholder="Search nodes\u2026"' +
                            ' oninput="CF.treeTable._onSearch(' + uid + ',this.value)" />' +
                    '</div>' +
                    '<div class="toolbar-actions">' +
                        '<div class="popup-wrap">' +
                            '<button class="tb-btn" onclick="togglePopup(\'' + colPopupId + '\')">' +
                                '<i class="fa-solid fa-table-columns"></i> Columns' +
                            '</button>' +
                            '<div id="' + colPopupId + '" class="col-toggle-popup popup-menu">' +
                                colItems +
                            '</div>' +
                        '</div>' +
                        filterBtn +
                        '<button class="tb-btn" onclick="CF.treeTable._expandAll(' + uid + ')">' +
                            '<i class="fa-solid fa-expand"></i> Expand All' +
                        '</button>' +
                        '<button class="tb-btn" onclick="CF.treeTable._collapseAll(' + uid + ')">' +
                            '<i class="fa-solid fa-compress"></i> Collapse All' +
                        '</button>' +
                        primaryBtn +
                        actionsBtn +
                    '</div>' +
                '</div>';

            card.insertAdjacentHTML('afterbegin', html);
        }

        // � Adopt existing toolbar from cshtml ---------------
        // Wires up event handlers on elements with data-cf-* attributes.
        function _adoptToolbarTop(toolbar, uid, columns, actions, hasFilter, primaryAction) {
            // Stamp permission dari konfigurasi JS ke tombol primary yang
            // sudah ada di cshtml agar applyGuards bisa menyembunyikannya
            var primaryBtnEl = toolbar.querySelector('[data-cf-primary-action]');
            if (primaryBtnEl && primaryAction && primaryAction.permission
                && !primaryBtnEl.hasAttribute('data-cf-permission')) {
                primaryBtnEl.setAttribute('data-cf-permission', primaryAction.permission);
            }

            // Wire search input [data-cf-search]
            var searchInput = toolbar.querySelector('[data-cf-search]');
            if (searchInput) {
                searchInput.id = searchInput.id || ('tt-search-' + uid);
                searchInput.addEventListener('input', function () {
                    CF.treeTable._onSearch(uid, this.value);
                });
            }

            // Wire column toggle popup [data-cf-col-popup] � auto-populate items
            var colPopup = toolbar.querySelector('[data-cf-col-popup]');
            if (colPopup) {
                colPopup.id = colPopup.id || ('tt-col-popup-' + uid);

                var tableEl = toolbar.closest('.table-card').querySelector('table');
                var headerCells = tableEl ? tableEl.querySelectorAll('thead th') : [];

                columns.forEach(function (col, i) {
                    if (col.tree || col.action) return;
                    var thEl = headerCells[i];
                    var title = (thEl ? thEl.textContent.trim() : '') || col.title || '';
                    if (!title) return;

                    var label = document.createElement('label');
                    label.className = 'col-toggle-item';
                    var cb = document.createElement('input');
                    cb.type = 'checkbox';
                    cb.checked = true;
                    cb.addEventListener('change', function () {
                        CF.treeTable._toggleColumn(uid, i, this.checked);
                    });
                    label.appendChild(cb);
                    label.appendChild(document.createTextNode(title));
                    colPopup.appendChild(label);
                });

                // Wire the toggle button for this popup
                var colBtn = toolbar.querySelector('[data-cf-col-toggle]');
                if (colBtn) {
                    colBtn.addEventListener('click', function (e) {
                        e.stopPropagation();
                        togglePopup(colPopup.id);
                    });
                }
            }

            // Wire filter button [data-cf-filter-btn]
            var filterBtn = toolbar.querySelector('[data-cf-filter-btn]');
            if (filterBtn) {
                filterBtn.addEventListener('click', function () {
                    openFilterModal();
                });
            }

            // Wire expand all [data-cf-expand-all]
            var expandBtn = toolbar.querySelector('[data-cf-expand-all]');
            if (expandBtn) {
                expandBtn.addEventListener('click', function () {
                    CF.treeTable._expandAll(uid);
                });
            }

            // Wire collapse all [data-cf-collapse-all]
            var collapseBtn = toolbar.querySelector('[data-cf-collapse-all]');
            if (collapseBtn) {
                collapseBtn.addEventListener('click', function () {
                    CF.treeTable._collapseAll(uid);
                });
            }

            // Wire primary action button [data-cf-primary-action]
            var primaryBtn = toolbar.querySelector('[data-cf-primary-action]');
            if (primaryBtn) {
                primaryBtn.addEventListener('click', function () {
                    CF.treeTable._onPrimaryAction(uid);
                });
            }

            // Wire actions dropdown popup [data-cf-actions-popup]
            var actPopup = toolbar.querySelector('[data-cf-actions-popup]');
            if (actPopup && actions && actions.length) {
                actPopup.id = actPopup.id || ('tt-act-popup-' + uid);

                actions.forEach(function (a, idx) {
                    if (a.divider) {
                        var div = document.createElement('div');
                        div.className = 'pm-divider';
                        actPopup.appendChild(div);
                    } else {
                        var item = document.createElement('div');
                        item.className = 'pm-item' + (a.danger ? ' danger' : '');
                        item.innerHTML = '<span class="pm-icon"><i class="' + (a.icon || '') + '"></i></span>' + a.label;
                        item.addEventListener('click', function () {
                            CF.treeTable._onAction(uid, idx);
                        });
                        actPopup.appendChild(item);
                    }
                });

                var actBtn = toolbar.querySelector('[data-cf-actions-toggle]');
                if (actBtn) {
                    actBtn.addEventListener('click', function (e) {
                        e.stopPropagation();
                        togglePopup(actPopup.id);
                    });
                }
            }
        }

        // � Inject filter bar --------------------------------
        function _injectFilterBar(card) {
            if (card.querySelector('#filter-bar')) return;
            var toolbar = card.querySelector('.table-toolbar-top');
            var target = toolbar;
            if (target) {
                target.insertAdjacentHTML('afterend', '<div id="filter-bar"></div>');
            }
        }

        // � Inject tree summary bar --------------------------
        function _injectSummaryBar(card, uid) {
            if (card.querySelector('#tt-summary-' + uid)) return;
            var filterBar = card.querySelector('#filter-bar');
            var target = filterBar || card.querySelector('.table-toolbar-top');
            if (target) {
                target.insertAdjacentHTML('afterend',
                    '<div id="tt-summary-' + uid + '" class="tree-summary"></div>');
            }
        }

        // � Inject row context menu --------------------------
        function _injectRowContextMenu(uid, rowActions) {
            if (!rowActions || !rowActions.length) return;

            var existingMenu = document.getElementById('row-ctx-menu');
            if (existingMenu) existingMenu.remove();

            var items = '';
            rowActions.forEach(function (ra) {
                if (ra.divider) {
                    items += '<div class="pm-divider"></div>';
                } else {
                    // data-cf-permission agar CF.permission.applyGuards
                    // menyembunyikan aksi yang tidak dimiliki user
                    var permAttr = ra.permission
                        ? ' data-cf-permission="' + ra.permission + '"'
                        : '';
                    items += '<div class="pm-item' + (ra.danger ? ' danger' : '') + '"' + permAttr +
                        ' onclick="CF.treeTable._onRowAction(' + uid + ',\'' + ra.action + '\')">' +
                        '<span class="pm-icon"><i class="' + (ra.icon || '') + '"></i></span>' +
                        ra.label +
                    '</div>';
                }
            });

            document.body.insertAdjacentHTML('beforeend',
                '<div id="row-ctx-menu">' + items + '</div>');
        }

        // � Inject toolbar bottom ----------------------------
        function _injectToolbarBottom(card, uid, defaultLen) {
            if (card.querySelector('.table-toolbar-bottom')) return null;

            var pageSizeId   = 'tt-page-size-'  + uid;
            var rowInfoId    = 'tt-row-info-'    + uid;
            var paginationId = 'tt-pagination-'  + uid;

            var options = CF.appConfig.pagination.pageSizeOptions;
            var optionsHtml = options.map(function (s) {
                return '<option value="' + s + '"' + (s === defaultLen ? ' selected' : '') + '>' + s + '</option>';
            }).join('');

            var html =
                '<div class="table-toolbar-bottom">' +
                    '<div class="toolbar-row-info">' +
                        '<div class="page-size-wrap">' +
                            'Show ' +
                            '<select class="page-size-select" id="' + pageSizeId + '"' +
                                ' onchange="CF.treeTable._onPageSizeChange(' + uid + ',this.value)">' +
                                optionsHtml +
                            '</select>' +
                            ' entries' +
                        '</div>' +
                        '<span id="' + rowInfoId + '"></span>' +
                    '</div>' +
                    '<div class="toolbar-pagination" id="' + paginationId + '"></div>' +
                '</div>';

            var tableWrap = card.querySelector('.table-wrap');
            if (tableWrap) {
                tableWrap.insertAdjacentHTML('afterend', html);
            } else {
                card.insertAdjacentHTML('beforeend', html);
            }

            return {
                pageSizeSelectId: pageSizeId,
                rowInfoId:        rowInfoId,
                paginationWrapId: paginationId
            };
        }

        // � Inject filter modal shell ------------------------
        function _injectFilterModalShell() {
            if (document.getElementById('modal-overlay')) return;
            var filterBody = document.getElementById('filter-body');
            if (!filterBody) return;

            var bodyContent = filterBody.innerHTML;
            filterBody.remove();

            var html =
                '<div id="modal-overlay" onclick="onOverlayClick(event)">' +
                    '<div class="modal-box">' +
                        '<div class="modal-header">' +
                            '<div class="modal-header-title"><i class="fa-solid fa-sliders"></i> Advanced Filter</div>' +
                            '<button class="modal-close" onclick="closeFilterModal()"><i class="fa-solid fa-xmark"></i></button>' +
                        '</div>' +
                        '<div class="modal-body">' + bodyContent + '</div>' +
                        '<div class="modal-footer">' +
                            '<button onclick="resetAllFilters(true)" class="tb-btn" style="color:#EF4444">' +
                                '<i class="fa-solid fa-rotate-left"></i> Reset All' +
                            '</button>' +
                            '<div style="display:flex;gap:8px;margin-left:auto">' +
                                '<button onclick="closeFilterModal()" class="tb-btn">Cancel</button>' +
                                '<button onclick="applyFilters()" class="tb-btn tb-btn-primary"><i class="fa-solid fa-check"></i> Apply Filter</button>' +
                            '</div>' +
                        '</div>' +
                    '</div>' +
                '</div>';

            document.body.insertAdjacentHTML('beforeend', html);
        }

        // � Apply column min-widths --------------------------
        function _applyColumnWidths(tableEl, columns) {
            var headerCells = tableEl.querySelectorAll('thead th');
            var totalMinPx = 0;

            columns.forEach(function (col, i) {
                var mw = parseInt(col.minWidth, 10);
                if (mw > 0) {
                    totalMinPx += mw;
                    if (headerCells[i]) headerCells[i].style.minWidth = col.minWidth;
                }
            });

            if (totalMinPx > 0) tableEl.style.minWidth = totalMinPx + 'px';
        }

        // � Inject skeleton tbody rows -----------------------
        function _injectSkeletonRows(tableEl) {
            var tbody = tableEl.querySelector('tbody');
            if (tbody) CF.skeleton.table(tbody);
        }

        // � Auto-expand all nodes (pre-render) ---------------
        // Sets expandedMap for every node that has children.
        // Called before _renderAll so rows are rendered expanded.
        function _autoExpandAll(ctx) {
            ctx.tree.ordered.forEach(function (id) {
                if (ctx.tree.childMap[id]) {
                    ctx.expandedMap[id] = true;
                }
            });
        }

        // � Inject sort indicators on thead -----------------
        function _initSortHeaders(tableEl, uid, columns) {
            var ths = tableEl.querySelectorAll('thead th');
            ths.forEach(function (th, i) {
                var col = columns[i];
                if (!col) return;
                if (col.action || th.classList.contains('no-sort')) return;
                if (col.sortable === false) return;

                // Remove any existing sort icon from a previous init call (group switch)
                var existingIcon = th.querySelector('.tt-sort-icon');
                if (existingIcon) existingIcon.remove();

                // Reset sort state classes from previous init
                th.classList.remove('tt-sort-asc', 'tt-sort-desc');
                th.dataset.sortDir = '';

                th.classList.add('tt-sortable');
                th.dataset.colIdx = i;
                th.dataset.sortField = col.sortField || col.field || '';

                var icon = document.createElement('span');
                icon.className = 'tt-sort-icon';
                icon.innerHTML = '<i class="fa-solid fa-sort"></i>';
                th.appendChild(icon);

                // Remove any previous listener by cloning the element
                var newTh = th.cloneNode(true);
                th.parentNode.replaceChild(newTh, th);
                newTh.addEventListener('click', function () {
                    _onHeaderSort(uid, this);
                });
            });
        }

        function _onHeaderSort(uid, th) {
            var ctx = _treeRegistry[uid];
            if (!ctx) return;

            var field = th.dataset.sortField;
            if (!field) return;

            var curDir = th.dataset.sortDir || '';
            var newDir = curDir === '' ? 'ASC' : curDir === 'ASC' ? 'DESC' : '';

            // Reset all other headers
            var ths = ctx.tableEl.querySelectorAll('thead th.tt-sortable');
            ths.forEach(function (h) {
                h.dataset.sortDir = '';
                h.classList.remove('tt-sort-asc', 'tt-sort-desc');
                var ic = h.querySelector('.tt-sort-icon i');
                if (ic) { ic.className = 'fa-solid fa-sort'; }
            });

            th.dataset.sortDir = newDir;
            var icon = th.querySelector('.tt-sort-icon i');
            if (newDir === 'ASC') {
                th.classList.add('tt-sort-asc');
                if (icon) { icon.className = 'fa-solid fa-sort-up'; }
            } else if (newDir === 'DESC') {
                th.classList.add('tt-sort-desc');
                if (icon) { icon.className = 'fa-solid fa-sort-down'; }
            } else {
                if (icon) { icon.className = 'fa-solid fa-sort'; }
            }

            if (typeof ctx.opts.onServerSort === 'function') {
                ctx.opts.onServerSort(newDir ? field : '', newDir);
            }
        }

        // � Main init ----------------------------------------
        function init(selector, opts) {
            var tableEl = document.querySelector(selector);
            if (!tableEl) return null;

            var card = tableEl.closest('.table-card');
            if (!card) return null;

            var uid = ++_treeCounter;
            var defaultLen = opts.pageLength || CF.appConfig.pagination.defaultPageSize;

            // Pre-fill tbody with skeleton rows so browser paints them first
            _injectSkeletonRows(tableEl);

            var tree = _buildTree(opts.data || [], opts);

            var colVisible = {};
            (opts.columns || []).forEach(function (_, i) { colVisible[i] = true; });

            var ctx = {
                uid:              uid,
                opts:             opts,
                tableEl:          tableEl,
                card:             card,
                tree:             tree,
                expandedMap:      {},
                colVisible:       colVisible,
                currentPage:      0,
                pageSize:         defaultLen,
                footerIds:        null,
                serverPagination: opts.serverPagination || null
            };

            _treeRegistry[uid] = ctx;

            // Check if #filter-body exists before injecting filter chrome
            var hasFilter = !!document.getElementById('filter-body');

            // Inject all chrome
            _injectToolbarTop(card, uid, opts.columns || [], opts.actions, hasFilter, opts.primaryAction);
            if (hasFilter) {
                _injectFilterBar(card);
            }
            _injectSummaryBar(card, uid);
            _injectRowContextMenu(uid, opts.rowActions);
            if (hasFilter) {
                _injectFilterModalShell();
            }

            ctx.footerIds = _injectToolbarBottom(card, uid, defaultLen);
            if (!ctx.footerIds) {
                ctx.footerIds = { pageSizeSelectId: '', rowInfoId: '', paginationWrapId: '' };
            }

            // Terapkan guard permission pada chrome yang baru disuntik.
            // Pada cache-hit, applyGuards global dari cf-auth berjalan
            // SEBELUM chrome ini ada — tanpa panggilan ini tombol
            // primary & row action tampil untuk user tanpa izin.
            if (typeof CF.permission !== 'undefined' && CF.permission.applyGuards) {
                CF.permission.applyGuards(document);
            }

            tableEl.classList.add('cf-table');
            _applyColumnWidths(tableEl, opts.columns || []);
            _initSortHeaders(tableEl, uid, opts.columns || []);

            // Let browser paint the skeleton first, then replace with real rows.
            // In server mode with empty initial data (serverInit pattern),
            // keep the skeleton visible � updateData() will replace it.
            var hasInitialData = (opts.data && opts.data.length > 0);
            if (hasInitialData) {
                requestAnimationFrame(function () {
                    setTimeout(function () {
                        _autoExpandAll(ctx);
                        _renderAll(ctx);
                    }, 300);
                });
            }

            return { uid: uid };
        }

        // � Internal callbacks -------------------------------
        function _toggle(uid, nodeId) {
            var ctx = _treeRegistry[uid];
            if (!ctx) return;

            ctx.expandedMap[nodeId] = !ctx.expandedMap[nodeId];

            // Update toggler icon
            var tr = document.getElementById('tt-row-' + uid + '-' + nodeId);
            if (tr) {
                var icon = tr.querySelector('.tt-toggler i');
                if (icon) {
                    icon.className = 'fa-solid ' + (ctx.expandedMap[nodeId] ? 'fa-chevron-down' : 'fa-chevron-right');
                    icon.style.fontSize = '10px';
                }
            }

            _refreshVisibility(ctx);
        }

        function _expandAll(uid) {
            var ctx = _treeRegistry[uid];
            if (!ctx) return;

            if (_isServerMode(ctx)) {
                // Server mode: expand all nodes in current data set
                ctx.tree.ordered.forEach(function (id) {
                    if (ctx.tree.childMap[id]) {
                        ctx.expandedMap[id] = true;
                        var tr = document.getElementById('tt-row-' + uid + '-' + id);
                        if (tr) {
                            var icon = tr.querySelector('.tt-toggler i');
                            if (icon) { icon.className = 'fa-solid fa-chevron-down'; icon.style.fontSize = '10px'; }
                        }
                    }
                });
            } else {
                var pageRoots = ctx.tree.rootIds.slice(ctx.currentPage * ctx.pageSize, (ctx.currentPage + 1) * ctx.pageSize);
                ctx.tree.ordered.forEach(function (id) {
                    var rootId = _getRootId(id, ctx.tree.nodeMap, ctx.opts.parentField || 'pid');
                    if (pageRoots.indexOf(rootId) >= 0 && ctx.tree.childMap[id]) {
                        ctx.expandedMap[id] = true;
                        var tr = document.getElementById('tt-row-' + uid + '-' + id);
                        if (tr) {
                            var icon = tr.querySelector('.tt-toggler i');
                            if (icon) { icon.className = 'fa-solid fa-chevron-down'; icon.style.fontSize = '10px'; }
                        }
                    }
                });
            }

            _refreshVisibility(ctx);
        }

        function _collapseAll(uid) {
            var ctx = _treeRegistry[uid];
            if (!ctx) return;

            if (_isServerMode(ctx)) {
                ctx.tree.ordered.forEach(function (id) {
                    ctx.expandedMap[id] = false;
                    var tr = document.getElementById('tt-row-' + uid + '-' + id);
                    if (tr) {
                        var icon = tr.querySelector('.tt-toggler i');
                        if (icon) { icon.className = 'fa-solid fa-chevron-right'; icon.style.fontSize = '10px'; }
                    }
                });
            } else {
                var pageRoots = ctx.tree.rootIds.slice(ctx.currentPage * ctx.pageSize, (ctx.currentPage + 1) * ctx.pageSize);
                ctx.tree.ordered.forEach(function (id) {
                    var rootId = _getRootId(id, ctx.tree.nodeMap, ctx.opts.parentField || 'pid');
                    if (pageRoots.indexOf(rootId) >= 0) {
                        ctx.expandedMap[id] = false;
                        var tr = document.getElementById('tt-row-' + uid + '-' + id);
                        if (tr) {
                            var icon = tr.querySelector('.tt-toggler i');
                            if (icon) { icon.className = 'fa-solid fa-chevron-right'; icon.style.fontSize = '10px'; }
                        }
                    }
                });
            }

            _refreshVisibility(ctx);
        }

        var _searchTimers = {};
        function _onSearch(uid, val) {
            clearTimeout(_searchTimers[uid]);
            _searchTimers[uid] = setTimeout(function () {
                var ctx = _treeRegistry[uid];
                if (!ctx) return;

                var q = val.trim();

                // Minimum 3 characters to trigger search, or empty to reset
                if (q.length > 0 && q.length < 3) return;

                // Server-side search: delegate to page script callback
                if (typeof ctx.opts.onServerSearch === 'function') {
                    ctx.opts.onServerSearch(q);
                    return;
                }

                // Client-side search (original behavior)
                _doSearch(uid, q.toLowerCase());
            }, 300);
        }

        function _doSearch(uid, q) {
            var ctx = _treeRegistry[uid];
            if (!ctx) return;

            var pidF = ctx.opts.parentField || 'pid';
            var idF = ctx.opts.idField || 'id';

            // Clear previous highlights
            ctx.tableEl.querySelectorAll('tbody tr').forEach(function (tr) {
                tr.classList.remove('tt-search-match');
            });

            if (!q) {
                _collapseAll(uid);
                return;
            }

            // Find matching nodes
            var matched = {};
            ctx.tree.ordered.forEach(function (id) {
                var node = ctx.tree.nodeMap[id];
                var searchable = '';
                ctx.opts.columns.forEach(function (col) {
                    if (col.field && !col.action) {
                        var val = node[col.field];
                        if (val !== null && val !== undefined) searchable += ' ' + String(val).toLowerCase();
                    }
                });
                if (searchable.indexOf(q) >= 0) matched[id] = true;
            });

            // Expand ancestors of matched nodes
            Object.keys(matched).forEach(function (id) {
                var node = ctx.tree.nodeMap[id];
                var pid = node[pidF];
                while (pid !== null && pid !== undefined && pid !== '') {
                    ctx.expandedMap[pid] = true;
                    var pTr = document.getElementById('tt-row-' + uid + '-' + pid);
                    if (pTr) {
                        var icon = pTr.querySelector('.tt-toggler i');
                        if (icon) { icon.className = 'fa-solid fa-chevron-down'; icon.style.fontSize = '10px'; }
                    }
                    var parent = ctx.tree.nodeMap[pid];
                    pid = parent ? parent[pidF] : null;
                }
            });

            _refreshVisibility(ctx);

            // Highlight
            Object.keys(matched).forEach(function (id) {
                var tr = document.getElementById('tt-row-' + uid + '-' + id);
                if (tr) tr.classList.add('tt-search-match');
            });
        }

        function _toggleColumn(uid, idx, visible) {
            var ctx = _treeRegistry[uid];
            if (!ctx) return;

            ctx.colVisible[idx] = visible;

            // Toggle header
            var ths = ctx.tableEl.querySelectorAll('thead th');
            if (ths[idx]) ths[idx].style.display = visible ? '' : 'none';

            // Toggle body cells
            ctx.tableEl.querySelectorAll('tbody tr').forEach(function (tr) {
                var tds = tr.querySelectorAll('td');
                if (tds[idx]) tds[idx].style.display = visible ? '' : 'none';
            });
        }

        function _goPage(uid, p) {
            var ctx = _treeRegistry[uid];
            if (!ctx) return;

            if (_isServerMode(ctx)) {
                // Server mode: delegate to page script
                var sp = ctx.serverPagination;
                var totalPages = sp ? (sp.totalPages || 1) : 1;
                if (p < 0 || p >= totalPages) return;
                if (typeof ctx.opts.onServerPage === 'function') {
                    ctx.opts.onServerPage(p + 1, ctx.pageSize); // 1-based page
                }
                return;
            }

            // Client mode
            var totalPages = Math.max(1, Math.ceil(ctx.tree.rootIds.length / ctx.pageSize));
            if (p < 0 || p >= totalPages) return;

            ctx.currentPage = p;
            Object.keys(ctx.expandedMap).forEach(function (k) { delete ctx.expandedMap[k]; });
            _autoExpandAll(ctx);
            _renderAll(ctx);
        }

        function _onPageSizeChange(uid, val) {
            var ctx = _treeRegistry[uid];
            if (!ctx) return;

            var newSize = parseInt(val, 10);
            ctx.pageSize = newSize;

            if (_isServerMode(ctx)) {
                if (typeof ctx.opts.onServerPageSize === 'function') {
                    ctx.opts.onServerPageSize(newSize);
                }
                return;
            }

            // Client mode
            ctx.currentPage = 0;
            Object.keys(ctx.expandedMap).forEach(function (k) { delete ctx.expandedMap[k]; });
            _autoExpandAll(ctx);
            _renderAll(ctx);
        }

        // � Action callbacks --------------------------------
        function _onAction(uid, idx) {
            var ctx = _treeRegistry[uid];
            if (!ctx) return;
            var action = ctx.opts.actions[idx];
            if (action && typeof action.onClick === 'function') {
                action.onClick();
            }
            document.querySelectorAll('.popup-menu.open, .actions-popup.open').forEach(function (p) { p.classList.remove('open'); });
        }

        function _onPrimaryAction(uid) {
            var ctx = _treeRegistry[uid];
            if (!ctx || !ctx.opts.primaryAction) return;
            if (typeof ctx.opts.primaryAction.onClick === 'function') {
                ctx.opts.primaryAction.onClick();
            }
        }

        function _onRowAction(uid, action) {
            var ctx = _treeRegistry[uid];
            if (!ctx) return;

            var node = null;
            var menu = document.getElementById('row-ctx-menu');
            if (menu && menu._sourceBtn) {
                var tr = menu._sourceBtn.closest('tr');
                if (tr) {
                    var nodeId = tr.getAttribute('data-id');
                    node = ctx.tree.nodeMap[nodeId];
                }
            }

            if (typeof ctx.opts.onRowAction === 'function') {
                ctx.opts.onRowAction(action, node);
            }

            closeRowMenu();
        }

        // � Public API ---------------------------------------
        function refresh(uid) {
            var ctx = _treeRegistry[uid];
            if (ctx) _renderAll(ctx);
        }

        // Update data and re-render (for server-side mode)
        function updateData(uid, newData, serverPagination) {
            var ctx = _treeRegistry[uid];
            if (!ctx) return;

            ctx.tree = _buildTree(newData || [], ctx.opts);
            ctx.expandedMap = {};

            if (serverPagination) {
                ctx.serverPagination = {
                    page: serverPagination.page || 1,
                    pageSize: serverPagination.pageSize || ctx.pageSize,
                    totalCount: serverPagination.totalCount,
                    totalPages: serverPagination.totalPages || Math.ceil(serverPagination.totalCount / ctx.pageSize)
                };
            } else {
                ctx.serverPagination = null;
            }

            _autoExpandAll(ctx);
            _renderAll(ctx);
        }

        // � Server-side shorthand ----------------------------
        function serverInit(selector, opts) {
            var loadFn  = opts.loadFn;
            var mapItem = opts.mapItem || function (item) { return item; };

            if (typeof loadFn !== 'function') {
                throw new Error('CF.treeTable.serverInit requires opts.loadFn');
            }

            // Internal state
            var _state = {
                search:   '',
                page:     1,
                pageSize: opts.pageLength || CF.appConfig.pagination.defaultPageSize,
                sortBy:   '',
                sortDir:  ''
            };

            // Clean opts for init() � remove serverInit-specific keys
            var initOpts = {};
            for (var k in opts) {
                if (opts.hasOwnProperty(k) && k !== 'loadFn' && k !== 'mapItem') {
                    initOpts[k] = opts[k];
                }
            }

            // Wire server-side callbacks before init
            initOpts.onServerSearch = function (query) {
                _state.search = query;
                _state.page = 1;
                _showLoadingSkeleton();
                _load();
            };
            initOpts.onServerPage = function (page, pageSize) {
                _state.page = page;
                _state.pageSize = pageSize;
                _showLoadingSkeleton();
                _load();
            };
            initOpts.onServerPageSize = function (pageSize) {
                _state.pageSize = pageSize;
                _state.page = 1;
                _showLoadingSkeleton();
                _load();
            };
            initOpts.onServerSort = function (sortBy, sortDir) {
                _state.sortBy = sortBy;
                _state.sortDir = sortDir;
                _state.page = 1;
                _showLoadingSkeleton();
                _load();
            };

            // Init immediately with empty data � toolbar/chrome appears,
            // skeleton stays in tbody until first loadFn completes
            initOpts.data = [];
            initOpts.serverPagination = { page: 1, pageSize: _state.pageSize, totalCount: 0, totalPages: 1 };

            var _ttInstance = init(selector, initOpts);

            // Show skeleton in tbody while waiting for data
            function _showLoadingSkeleton() {
                if (!_ttInstance) return;
                var ctx = _treeRegistry[_ttInstance.uid];
                if (!ctx) return;
                var tbody = ctx.tableEl.querySelector('tbody');
                if (tbody) CF.skeleton.table(tbody);
            }

            // The handle returned to the page script
            var handle = {
                uid: _ttInstance ? _ttInstance.uid : null,

                // Called by the page script's loadFn when API responds
                loaded: function (items, serverPagination) {
                    var data = (items || []).map(mapItem);
                    var sp = {
                        page:       (serverPagination && serverPagination.page)       || _state.page,
                        pageSize:   (serverPagination && serverPagination.pageSize)    || _state.pageSize,
                        totalCount: (serverPagination && serverPagination.totalCount)  || 0,
                        totalPages: (serverPagination && serverPagination.totalPages)  || 1
                    };

                    if (_ttInstance) {
                        updateData(_ttInstance.uid, data, sp);
                    }
                },

                // Reload with current or overridden params
                reload: function (overrides) {
                    if (overrides) {
                        if (overrides.search   !== undefined) _state.search   = overrides.search;
                        if (overrides.page     !== undefined) _state.page     = overrides.page;
                        if (overrides.pageSize !== undefined) _state.pageSize = overrides.pageSize;
                        if (overrides.sortBy   !== undefined) _state.sortBy   = overrides.sortBy;
                        if (overrides.sortDir  !== undefined) _state.sortDir  = overrides.sortDir;
                    }
                    _showLoadingSkeleton();
                    _load();
                },

                // Get current state (read-only copy)
                getState: function () {
                    return {
                        search:   _state.search,
                        page:     _state.page,
                        pageSize: _state.pageSize,
                        sortBy:   _state.sortBy,
                        sortDir:  _state.sortDir
                    };
                }
            };

            function _load() {
                loadFn({
                    search:   _state.search,
                    page:     _state.page,
                    pageSize: _state.pageSize,
                    sortBy:   _state.sortBy,
                    sortDir:  _state.sortDir
                }, handle);
            }

            // Trigger initial load (skeleton already visible from init)
            _load();

            return handle;
        }

        // � Expose public methods ---------------------------
        return {
            init:               init,
            serverInit:         serverInit,
            updateData:         updateData,
            _toggle:            _toggle,
            _goPage:            _goPage,
            _onPageSizeChange:  _onPageSizeChange,
            _expandAll:         _expandAll,
            _collapseAll:       _collapseAll,
            _onSearch:          _onSearch,
            _toggleColumn:      _toggleColumn,
            _onAction:          _onAction,
            _onPrimaryAction:   _onPrimaryAction,
            _onRowAction:       _onRowAction
        };
    })();

    // � Global helper functions --------------------------
    // Only define if not already defined (cf-datatable.js may define them first)
    if (typeof window.openRowMenu !== 'function') {
        window.openRowMenu = function (evt, btn) {
            evt.stopPropagation();
            var menu = document.getElementById('row-ctx-menu');
            if (!menu) return;

            menu._sourceBtn = btn;

            var rect = btn.getBoundingClientRect();
            var mh = 160, mw = 190;
            var openUp = rect.bottom + mh > window.innerHeight;
            menu.style.top  = (openUp ? rect.top  - mh - 4 : rect.bottom + 4) + 'px';
            menu.style.left = Math.min(rect.right - mw, window.innerWidth - mw - 8) + 'px';

            menu.classList.add('show');
        };
    }

    if (typeof window.closeRowMenu !== 'function') {
        window.closeRowMenu = function () {
            var menu = document.getElementById('row-ctx-menu');
            if (menu) menu.classList.remove('show');
        };
    }

    if (typeof window.onOverlayClick !== 'function') {
        window.onOverlayClick = function (evt) {
            if (evt.target.id === 'modal-overlay') {
                closeFilterModal();
            }
        };
    }
})();
